import { render } from "./allstudresult.vue?vue&type=template&id=833b6068&scoped=true"
import script from "./allstudresult.vue?vue&type=script&lang=js"
export * from "./allstudresult.vue?vue&type=script&lang=js"

import "./allstudresult.vue?vue&type=style&index=0&id=833b6068&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-833b6068"]])

export default __exports__